import React from 'react'
import RootWrapper from './src/components/RootWrapper'

export const wrapRootElement = ({ element }) => <RootWrapper>{element}</RootWrapper>
